export const removeToasts = () => {
  const toastyContainer = document.querySelector('.Toastify');
  const firstChild = toastyContainer?.children?.[0];

  if (firstChild && firstChild?.children?.length > 0) {
    const grandChild = firstChild?.children?.[0];
    grandChild?.remove();
    return;
  }

  const toastyContainerSecondOption = document.querySelector('.Toastify__toast');
  toastyContainerSecondOption?.remove();
}
